import { Controller } from '@hotwired/stimulus'
import { createErrorHintElement } from '../utils/dom'

export default class CheckboxController extends Controller {
  static targets = ['input', 'errors']
  static values = {
    requiredMessage: String,
    // CSS-селектор поля, заполненность которого делает чекбокс обязательным.
    // Нужен согласию на обработку данных: без e-mail принимать его не надо.
    requiredIfFilled: String
  }

  #errorHintElement = null
  #conditionField = null

  #syncRequired = () => {
    const isRequired = this.#conditionField.value.trim().length > 0

    this.inputTarget.required = isRequired
    // Снятое требование не должно оставлять на экране прежнюю ошибку.
    if (!isRequired) this.showErrors([])
  }

  connect() {
    if (!this.hasRequiredIfFilledValue) return

    const scope = this.element.closest('form') ?? document

    this.#conditionField = scope.querySelector(this.requiredIfFilledValue)
    if (!this.#conditionField) return

    this.#conditionField.addEventListener('input', this.#syncRequired)
    this.#conditionField.addEventListener('change', this.#syncRequired)
    this.#syncRequired()
  }

  disconnect() {
    if (!this.#conditionField) return

    this.#conditionField.removeEventListener('input', this.#syncRequired)
    this.#conditionField.removeEventListener('change', this.#syncRequired)
    this.#conditionField = null
  }

  validate() {
    const errors = []

    if (this.inputTarget.required && !this.inputTarget.checked) {
      errors.push(
        this.hasRequiredMessageValue
          ? this.requiredMessageValue
          : 'This field is required'
      )
    }

    this.showErrors(errors)
    return errors.length === 0
  }

  showError(message) {
    this.showErrors(message ? [message] : [])
  }

  showErrors(errors) {
    const hasErrors = errors.length > 0

    this.element.classList.toggle('is-invalid', hasErrors)

    if (this.#errorHintElement) {
      this.#errorHintElement.remove()
      this.#errorHintElement = null
    }

    if (this.hasErrorsTarget && hasErrors) {
      this.#errorHintElement = createErrorHintElement(
        errors[0],
        this.element.classList.contains('checkbox--no-inverse')
      )
      this.errorsTarget.appendChild(this.#errorHintElement)
    }
  }

  reset() {
    this.element.classList.remove('is-invalid')

    if (this.#errorHintElement) {
      this.#errorHintElement.remove()
      this.#errorHintElement = null
    }

    this.inputTarget.setCustomValidity('')
  }
}
